module.exports = __webpack_public_path__ + "static/media/moon.7eb5ccff.m4a";